import { env } from '@/env'

export const APP_DATA_VERSION =
  env.NEXT_PUBLIC_PGEE_APP_DATA_VERSION
